import { useCallback, useState } from 'react'

import {
  ImportProcessValidateEmailsDocument,
  type ImportProcessValidateEmailsQuery,
} from 'generated/resources/graphql'

import { useLazyQuery } from 'modules/core/hooks/useQuery'

import { type ExistingEmployeesByEmail } from 'modules/employees/lib/validateEmailForCreation'

import ImportProcessWizard from './components/ImportProcessWizard'

function buildEmployeesByEmail(
  data: ImportProcessValidateEmailsQuery | undefined
): ExistingEmployeesByEmail {
  const map: ExistingEmployeesByEmail = new Map()
  if (!data) return map

  for (const employee of data.employees.employees) {
    const email = employee.access.email
    if (email) {
      map.set(email, { active: employee.active ?? true })
    }
  }

  return map
}

const ImportProcessPage = () => {
  const [existingEmployeesByEmail, setExistingEmployeesByEmail] =
    useState<ExistingEmployeesByEmail>(new Map())

  const [executeQuery] = useLazyQuery(ImportProcessValidateEmailsDocument)

  const fetchEmailValidation = useCallback(
    async (emails: string[]): Promise<ExistingEmployeesByEmail> => {
      if (emails.length === 0) return new Map()

      const { data } = await executeQuery({ variables: { emails } })
      const map = buildEmployeesByEmail(data)
      setExistingEmployeesByEmail(map)
      return map
    },
    [executeQuery]
  )

  return (
    <ImportProcessWizard
      existingEmployeesByEmail={existingEmployeesByEmail}
      fetchEmailValidation={fetchEmailValidation}
    />
  )
}

export default ImportProcessPage
